import React from 'react';
import MultiSelectCell from '@atlassian/jira-portfolio-3-portfolio/src/common/view/multi-select-cell';
import type { Props } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/multi-select-cell/types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ isReadOnly, ...props }: Props) => (
	<MultiSelectCell {...props} isDisabled={isReadOnly} isReadOnly={isReadOnly} />
);
